import React from "react";
import styled from "@emotion/styled";
import { normalizePhoneForDisplay } from "@components/validation/editProfileForm";

const Body = styled.div`
  padding: ${props => (props.noPaddingAndMargin ? 0 : "30px 30px 19px 30px")};
  color: ${props => props.setColor};
  @media (max-width: 375px) {
    padding-right: ${props =>
      props.noPaddingAndMargin ? 0 : "15px !important"};
    padding-left: ${props =>
      props.noPaddingAndMargin ? 0 : "15px !important"};
  }
`;

const LineItem = styled.p`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  margin-bottom: 2px;
`;

const Address = styled.address`
  margin-bottom: ${props => (props.noPaddingAndMargin ? 0 : "1rem")};
`;

const CustomerBuyAddressNew = ({
  customerInfo,
  phoneNumberForm,
  setOpacity = 1,
  noPaddingAndMargin
}) => (
  <div>
    <Body
      setColor={`rgba(119, 121, 132, ${setOpacity})`}
      className="customer-address-display"
      noPaddingAndMargin={noPaddingAndMargin}
    >
      <Address noPaddingAndMargin={noPaddingAndMargin}>
        {phoneNumberForm ? (
          <LineItem>{normalizePhoneForDisplay(customerInfo.phone)}</LineItem>
        ) : (
          <>
            <LineItem>
              {customerInfo.firstname} {customerInfo.lastname}
            </LineItem>
            <LineItem>{`${customerInfo.street} ${
              customerInfo.street2 ? customerInfo.street2 : ""
            }`}</LineItem>
            <LineItem>
              {customerInfo.city}, {customerInfo.state}, {customerInfo.zip}
            </LineItem>
          </>
        )}
      </Address>
    </Body>
  </div>
);

export default CustomerBuyAddressNew;
